
(function($){
    $.Metro = function(params){
        params = $.extend({}, params);
    };

    $.Metro.getDeviceSize = function(){
        var device_width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        var device_height = (window.innerHeight > 0) ? window.innerHeight : screen.height;
        return {
            width: device_width,
            height: device_height
        }
    }

    $.Metro.METRO_AUTO_REINIT=true;
    $.Metro.METRO_LOCALE=undefined;
    $.Metro.METRO_WEEK_START=undefined;
    $.Metro.METRO_DIALOG=false;

})(jQuery);

$(function(){
    $('html').on('click', function(e){
        $('.dropdown-menu').each(function(i, el){
            if (!$(el).hasClass('keep-open') && $(el).css('display')=='block') {
                $(el).hide();
            }
        });
    });
});

$(function(){
    $(window).on('resize', function(){
        if ($.Metro.METRO_DIALOG) {
            var top = ($(window).height() - $.Metro.METRO_DIALOG.outerHeight()) / 2;
            var left = ($(window).width() - $.Metro.METRO_DIALOG.outerWidth()) / 2;
            $.Metro.METRO_DIALOG.css({
                top: top, left: left
            });
        }
    });
});
